import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {DbServerErrors} from "../shared/interceptors/db-server-errors";
import {DbResponse} from "../shared/interceptors/db-response";
import {IFcDropdownSelectOption} from "../shared/components/form-controls/dropdown-select/fc-dropdown-select-option";
import {Notification} from "../shared/components/notifier/notification";
import {NotificationType} from "../shared/components/notifier/notification-type";
import {NotifierComponent} from "../shared/components/notifier/notifier.component";
import {UserService} from "../user/user.service";
import {DbValidators} from "../shared/validators/DbValidators";
import {User} from "../user/user";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.scss'],
    standalone: false
})
export class ContactUsComponent implements OnInit {
  public loading: boolean;

  public _user: User;
  public contactUsForm: FormGroup;
  public serverErrors: DbServerErrors;
  public formSubmitted: boolean;
  public inquiryType: FormControl;
  public customerServiceSupport: FormControl;
  public inquiryTypeOptions: IFcDropdownSelectOption[];
  public customerServiceSupportOptions: IFcDropdownSelectOption[];

  constructor(
    public _userService: UserService,
    private _route: ActivatedRoute,
  ) {

  }
  ngOnInit(): void {
    this._user = this._route.snapshot.data['user'];
    this.initValues();
    this.inquiryTypeOptions = [
      {
        value: '',
        label: 'Inquiry type'
      },
      {
        value: 'customerServiceSupport',
        label: 'Customer service support'
      },
      {
        value: 'mediaPr',
        label: 'Media/PR'
      },
      {
        value: 'partnerInquiry',
        label: 'Partner inquiry'
      },
      {
        value: 'productsSolutionInquiry',
        label: 'Products / Solution Inquiry'
      },
      {
        value: 'other',
        label: 'Other'
      }
    ];
    this.customerServiceSupportOptions = [
      {
        value: '',
        label: 'Select product/services'
      },
      {
        value: 'managerPluginDashboard',
        label: 'Manager plugin/dashboard'
      },
      {
        value: 'formMakerPlugin',
        label: 'Form Maker plugin'
      },
      {
        value: 'photoGalleryPlugin',
        label: 'Photo Gallery plugin'
      },
      {
        value: 'backupService',
        label: 'Backup service'
      },
      {
        value: 'imageOptimizerService',
        label: 'Image Optimizer service'
      },
      {
        value: 'eventCalendarPlugin',
        label: 'Event Calendar plugin'
      },
      {
        value: 'wordpressThemes',
        label: 'WordPress themes'
      },
      {
        value: 'otherPluginsAddOns',
        label: 'Other plugins/add-ons'
      },
      {
        value: 'general',
        label: 'General'
      }
    ];
  }
  public initValues(): void {
    this.formSubmitted = false;
    this.inquiryType = new FormControl('');
    this.customerServiceSupport = new FormControl('');
    this.contactUsForm = new FormGroup({
      'fullName': new FormControl(this._user.firstName + " " + this._user.lastName),
      'email': new FormControl(this._user.email, [DbValidators.trim, Validators.required, Validators.email, Validators.pattern(/^[+_\-a-zA-Z0-9]+(\.[+_\-a-zA-Z0-9]+)*@[+_\-a-zA-Z0-9]+(\.[+_\-A-Za-z0-9]+)*(\.[+_\-A-Za-z]{2,24})$/)]),
      'inquiryType': this.inquiryType,
      'customerServiceSupport': this.customerServiceSupport,
      'subject': new FormControl(''),
      'message': new FormControl('', [Validators.required]),
    });
    this.contactUsForm.markAsUntouched();
  }
  public onFormSubmit(): void {
    this.formSubmitted = true;
    if (this.contactUsForm.valid) {
      this.loading = true;
      this.serverErrors = null;
      this._userService.contactUs(this.contactUsForm.value)
        .pipe(filter((response: DbResponse): boolean => !!response),
        first())
        .subscribe((response: DbResponse): void => {
          this.loading = false;
          if (response.success) {
            this.initValues();
            NotifierComponent.notify(new Notification("Thank you for contacting us. We'll get back to you soon!", NotificationType.SUCCESS));
          }
          else {
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
            this.serverErrors = response.serverErrors;
          }

        });
    }
  }
}
